import React from 'react';
import Typography, { TypographyProps } from './Typography';

export interface TypographyLabelValueProps extends Omit<TypographyProps, 'classes'> {
  className?: string;
  label: React.ReactNode;
  value: string;
  symbolForEmptyValues?: string;
  labelClassName?: string;
  valueClassName?: string;
}

const TypographyLabelValue: React.FC<TypographyLabelValueProps> = ({
  label,
  value,
  symbolForEmptyValues,
  labelClassName,
  valueClassName,
  ...rest
}) => {
  const transformedValue = !value && symbolForEmptyValues ? symbolForEmptyValues : value;
  return (
    <Typography {...rest}>
      <Typography variant="inherit" color="inherit" className={labelClassName}>
        {label}
      </Typography>
      <Typography variant="inherit" color="inherit" className={valueClassName}>
        {transformedValue}
      </Typography>
    </Typography>
  );
};

export default TypographyLabelValue;
